module.exports = __webpack_public_path__ + "img/image10.7b7e39fa.png";